import cx from "classnames";

import Image from "common/components/Image";

import { ImageBlock as ImageBlockType } from "../../types";

import styles from "../../styles/ImageBlock.module.less";

type ImageBlockProps = {
  className: string;
  block: ImageBlockType;
};

const ImageBlock = ({ block, className }: ImageBlockProps) => {
  return (
    <Image
      className={cx(className, styles.image, block.rounded && styles.rounded)}
      src={block.source}
      alt={block.alt}
    />
  );
};

export default ImageBlock;
